<template>
  <div class="block">
    <date-picker
        v-model="dateValue"
        type="date"
        placeholder="เลือกวันที่"
        format="DD/MM/YYYY"
        value-format="DD/MM/YYYY">
    </date-picker>
    <input type="hidden" :name="name" :value="dateValue">
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/index.css';

export default {
  props: {
    name: {
      type: String,
      default: 'start_date'
    },
  },
  components: {
      DatePicker
  },
  data() {
    return {
      dateValue: '',
    };
  }
};
</script>